import { render } from "./off_course_invoices.vue?vue&type=template&id=ec8f852a&scoped=true"
import script from "./off_course_invoices.vue?vue&type=script&lang=js"
export * from "./off_course_invoices.vue?vue&type=script&lang=js"

import "./off_course_invoices.vue?vue&type=style&index=0&id=ec8f852a&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec8f852a"]])

export default __exports__